import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { CHANNEL_SOURCE, EMPOWER_TYPE, loginSDK, type Channels } from '@eureka/shared/login-sdk';

export interface LoginDialogService {
    open(withoutClose?: boolean, channels?: Channels): Promise<void>
}

@injectable()
export class LoginDialogServiceImpl implements LoginDialogService {
    private _channels: Channels = {
        from_page: EMPOWER_TYPE.AIR_HOME,
        channel_source: CHANNEL_SOURCE.AIR_EUREKA,
    }

    constructor(
    ) {
        loginSDK.setChannels(this._channels)
        loginSDK.handleThirdPartyLoginErrors()
    }

    open(
        withoutClose = false,
        channels?: Channels
    ) {
        if (channels) {
            this._channels = channels
            loginSDK.setChannels(this._channels)
        }
        return loginSDK.open({
            withoutClose,
        }).then(async() => {
            window.location.reload();
        })
    }
}

export const LoginDialogService = Symbol('LoginDialogService');
